import { Component, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthService } from '../../../auth/auth.service';
import { DestinatariosService } from '../../destinatarios/destinatarios.service';
import { Destinatario } from '../../../../asistente-en-linea/models/Destinatario';
import { AbstractControl, FormControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MenuService } from '../../menu/menu.service';

@Component({
  selector: 'app-destinatario',
  templateUrl: './destinatario.component.html',
  styleUrls: ['./destinatario.component.scss']
})
export class DestinatarioComponent implements OnInit {
  cargandoDatos: boolean;
  destinatarioSeleccionado: Destinatario;
  codigo: string;
  descripcion: string;
  titulo: string;
  target: string;
  error: string;
  targetType: string = "EMAIL";
  encoladoMaximo: number;
  reenviarHistorico = true;
  habilitado: boolean;
  editando: boolean;
  idDestinatario: string;
  loading: boolean;
  errorValidacion: boolean;
  esUsuarioAdminitrador: boolean;
  horaInicio: string = "";
  horaFin: string = "";
  tiposDestinatarioMap: Map<string, string>;
  tiposDestinatarioReverseMap = new Map<string, string>()
  tiposDestinatarioList: string[];

  opcionesTipo: { label: string; value: string }[] = [
    { label: "Correo electrónico", value: "EMAIL" },
    { label: "Chat", value: "Workgroup" }
  ];

  constructor(private destinatarioService: DestinatariosService,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private readonly menuService: MenuService) {
    this.loading = false;
    this.errorValidacion = false;
    this.esUsuarioAdminitrador = false;
    this.tiposDestinatarioMap = new Map<string, string>()
      .set("Correo electrónico", "EMAIL");

    this.tiposDestinatarioReverseMap = new Map<string, string>()
      .set("EMAIL", "Correo electrónico");
    this.tiposDestinatarioList = Array.from(this.tiposDestinatarioMap.keys());
  }



  ngOnInit() {
    this.habilitado = true;
    this.route.queryParamMap.subscribe((params: any) => {
      this.idDestinatario = params.params.idDestinatario;
      if (this.idDestinatario) {
        this.editando = true;
        this.loadDestinatario();
      }
    })
  }

  volver() {
    this.router.navigate(['/config/destinatarios']);
  }

  loadDestinatario() {
    this.cargandoDatos = true;
    this.destinatarioService.lloadDestinatarioByID(this.idDestinatario).subscribe((data: any) => {
      //debugger
      if (data && (data.statusCode == 200 || data.statusCode == 0)) {
        let menuBD = data.content;
        this.habilitado = menuBD.habilitado != null ? menuBD.habilitado : false;
        this.descripcion = menuBD.descripcion;
        this.titulo = menuBD.titulo;
        this.target = menuBD.target;
        this.codigo = menuBD.codigo;
        this.targetType = menuBD.targetType
        if (this.targetType == "Workgroup") {
          this.horaInicio = menuBD.horaInicio ? menuBD.horaInicio.slice(0, 5) : "";
          this.horaFin = menuBD.horaFin ? menuBD.horaFin.slice(0, 5) : "";
        }
        this.cargandoDatos = false;
      }
      else {
        alert(data.statusMessage);
        this.cargandoDatos = false;
      }
    },
      error => {
        alert(error);
        this.cargandoDatos = false;
      })
  }

  emailArrayValidator(email, targetType) {
    if(targetType && targetType!='Workgroup') {
      if (!email ) {
        return false;
      }
      this.error = "";
      const innerControl = new FormControl(email, Validators.email);
      if (innerControl.errors && innerControl.errors.email) {
        this.error = "Por favor, asegúrese de ingresar correctamente el correo electrónico.";
        return false;
      }
      return true;
    } else {
      return true;
    } 
  }

  irPaginaInicio() {
    this.router.navigate(['/config/destinatarios/']);
  }

  cancelOperation() {
    this.irPaginaInicio();
  }
  async applyOperation() {
    let resArray = [];
    this.errorValidacion = false;
    if (this.isCreateDestinatarioDataValid()) {
      if (this.emailArrayValidator(this.target, this.targetType)) {
        this.loading = true;
        let idDest;
        // let tipo = this.tiposDestinatarioMap.get(this.targetType);
        let tipo = this.targetType
        if (this.idDestinatario) {
          resArray.push(await this.destinatarioService.actualizarDestinatario(this.idDestinatario, this.codigo, this.descripcion, this.titulo, tipo, this.target,
            this.authService.getUser().username, this.habilitado, this.horaInicio, this.horaFin)
            .toPromise().catch((err) => {
              this.loading = false;
              alert(err);
            }));

        } else {
          resArray.push(await this.destinatarioService.agregarDestinatario(this.codigo, this.descripcion, this.titulo, tipo, this.target,
            this.authService.getUser().username, this.horaInicio, this.horaFin)
            .toPromise().catch((err) => {
              this.loading = false;
              alert(err);
            }));

        }

        let noErr = resArray.reduce((previous, current) => {
          idDest = current.id;
          return previous && (current.statusCode == 200 || current.statusCode == 0 ? true : false);
        }, true)

        if (noErr) {
          this.loading = false;
          let idDestFin = 0;
          if (idDest) {
            idDestFin = Number(idDest);
          }
          if (idDestFin < 0) {
            if (idDest === '-1') {
              this.error = "Atención: Ya existe otro destinatario con el mismo código";
            } else if (idDest === '-2') {
              this.error = "Atención: Ya existe otro destinatario con el mismo título";
            } else {
              this.error = "Atención: Ya existe otro destinatario con el mismo código y título";
            }
            this.errorValidacion = true;
          } else {
            this.irPaginaInicio();
          }
        } else {
          this.loading = false;
          alert("Ocurrió un error, intente nuevamente más tade");
        }
      } else {
        this.errorValidacion = true;
      }
    } else {
      this.errorValidacion = true;
    }

  }

  isCreateDestinatarioDataValid() {
    this.error = "";
    if (this.codigo && this.descripcion && this.titulo && this.target && this.targetType && this.validarCamposHora()) {
      return true;
    } else {
      this.error = this.error.length == 0 ? "Por favor, asegúrese de ingresar todos los campos obligatorios" : this.error;
      return false;
    }
  }

  salirAdministrador() {
    this.menuService.salirAdministrador();
    this.router.navigate(["/login"]);
  }

  validarCamposHora(): boolean {
    // solo valido para "CHAT"
    if (this.targetType == "EMAIL") return true;

    // valido formato de la hora de inicio
    if (!this.validarHora(this.horaInicio)) {
      this.error = "La hora de inicio no es válida.";
      return false;
    }

    // valido formato de la hora de fin
    if (!this.validarHora(this.horaFin)) {
      this.error = "La hora de fin no es válida.";
      return false;
    }

    // valido que hora fin sea posterior a hora inicio
    if (!this.validacionFechasMayor(this.horaFin, this.horaInicio)) {
      this.error = "La hora de fin debe ser posterior a la hora de inicio.";
      return false;
    }

    return true;

  }

  validarHora(valor: string): boolean {

    // valido que tenga ":"
    if (!valor.includes(':')) {
      return false;
    }

    // dividio en horas y minutos
    const partes = valor.split(':');
    if (partes.length !== 2) {
      return false;
    }

    const hora = parseInt(partes[0], 10);
    const minutos = parseInt(partes[1], 10);

    // valido que ambas partes sean números válidos
    if (isNaN(hora) || isNaN(minutos)) {
      return false;
    }

    // validar rangos
    if (hora < 0 || hora > 23) {
      return false;
    }

    if (minutos < 0 || minutos > 59) {
      return false;
    }

    return true;
  }

  asegurarFormatoHoraInicio() {
    let horaIngresada = this.horaInicio;
    this.horaInicio = this.asegurarFormatoHora(this.horaInicio);
    this.error = this.horaInicio.length == 0 && horaIngresada.length > 0 ? "El valor " + horaIngresada + " no es válido." : ""
  }

  asegurarFormatoHoraFin() {
    let horaIngresada = this.horaFin;
    this.horaFin = this.asegurarFormatoHora(this.horaFin);
    this.error = this.horaFin.length == 0 && horaIngresada.length > 0 ? "El valor " + horaIngresada + " no es válido." : ""
  }

  asegurarFormatoHora(valorHora): string {
    // valido que la hora no sea vacía
    if (valorHora.length == 0) {
      return "";
    }

    if (valorHora.length == 2) {
      valorHora = valorHora + ":" + '00';
    }

    // si es de 4, agrego el ':' en el medio
    if (valorHora.length === 4) {
      valorHora = valorHora.slice(0, 2) + ":" + valorHora.slice(2);
    }

    return this.validarHora(valorHora) ? valorHora : "";
  }

  validacionFechasMayor(fecha1: string, fecha2: string): boolean {
    const [horas1, minutos1] = fecha1.split(':').map(Number);
    const [horas2, minutos2] = fecha2.split(':').map(Number);

    // transformo todo a minutos
    const totalMinutos1 = horas1 * 60 + minutos1;
    const totalMinutos2 = horas2 * 60 + minutos2;

    return totalMinutos1 > totalMinutos2;
  }


}